import classnames from 'classnames';
import React from 'react';

// eslint-disable-next-line import-x/no-cycle
import { DropdownTimezoneContext } from '.';

type Props = {
  active?: boolean;
  tz?: string;
} & React.PropsWithChildren;

export const DropdownTimezoneButton: React.FC<Props> = ({ active = false, children, tz }) => {
  const context = React.useContext(DropdownTimezoneContext);

  if (!context) {
    throw new Error('DropdownTimezoneButton must be used inside DropdownTimezone.');
  }

  const { alignment, onTimezoneChange } = context;

  const flip = alignment === 'right';

  const handleClick = tz ? () => onTimezoneChange(tz) : undefined;

  return (
    <button
      className={classnames(
        'dropdown-timezone__button',
        { 'dropdown-timezone__button--active': active },
        { 'dropdown-timezone__button--flip': flip },
        {
          'dropdown-timezone__button--has-submenu': !tz,
        }
      )}
      onClick={handleClick}
      role="menuitem"
      type="button"
    >
      {children}
    </button>
  );
};
